import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserInfo } from '../../../../models/user-info.model';
import { Error } from 'src/app/models/error.model';
import { SharemailboxListFields } from 'src/app/models/sharemailbox-list-fields.model';
import {
  GraphService,
  SharemailboxStatus,
} from 'src/app/services/graph/graph.service';
import { lastValueFrom } from 'rxjs';
import { LocalStorageService } from 'src/app/services/localStorage/localStorage.service';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { AddUserDialogComponent } from '../../adduser-dialog/adduser-dialog.component';
import { UsersService } from 'src/app/services/users/users.service';
import { GECorrespondingTable } from 'src/app/models/ge-corresponding-table.model';

@Component({
  selector: 'app-sharemailbox-add-dialog',
  templateUrl: './sharemailbox-add-dialog.html',
  styleUrls: ['./sharemailbox-add-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SharemailboxAddDialogComponent implements OnInit {
  errorCreateSharemailbox: Error = { error: { message: '', code: '' } };
  isErrorCreateSharemailbox = false;
  issharemailboxCreated = false;
  isBusyCreateSharemailbox = false;

  error: Error = { error: { message: '', code: '' } };

  currentUser: UserInfo;

  nameValidator = '^[\\wÀ-ÖØ-öø-ÿ\\s-]+$';

  maxlength = 64;

  addSharemailBoxForm: FormGroup;
  isSharemailBoxCreated = false;

  // Form to Bolean
  ajout_Directeur = false;
  ajout_ConseilDir = false;
  ajout_secDir = false;
  ajout_admin = false;
  ajout_Tech = false;
  ajout_ITRes = false;
  ajout_ITGest = false;

  ajout_Nominatif = false;

  sendas_Directeur = false;
  sendas_ConseilDir = false;
  sendas_secDir = false;
  sendas_admin = false;
  sendas_Tech = false;
  sendas_ITRes = false;
  sendas_ITGest = false;

  sendas_Nominatif = false;

  users_acces: UserInfo[] = [];
  user_sendAs_Nom: UserInfo[] = [];

  currentGE = '';
  currentGECorrespondingTable: GECorrespondingTable;

  spinner = {
    color: 'primary',
    mode: 'indeterminate' as ProgressSpinnerMode,
    value: 50,
    diameter: 50,
  };

  constructor(
    public matDialogRef: MatDialogRef<SharemailboxAddDialogComponent>,
    private _formBuilder: FormBuilder,
    private _matDialog: MatDialog,
    private _graphService: GraphService,
    private _userService: UsersService,
    private _localStorageService: LocalStorageService
  ) {
    this.currentUser = this._userService.currentUserValue;
    this.addSharemailBoxForm = this._formBuilder.group({
      sharemailboxName: [
        '',
        [
          Validators.required,
          Validators.pattern(this.nameValidator),
          Validators.maxLength(this.maxlength),
        ],
      ],
    });
  }

  ngOnInit(): void {
    this.currentGE = this._localStorageService.getItem<string>('userDefaultGE');
    this.currentGECorrespondingTable = {
      title: this.currentGE,
    };
    this.getGECorespondingTable();
  }

  async getGECorespondingTable(): Promise<void> {
    try {
      await lastValueFrom(
        this._graphService.selectGeInCorrespondingTable(
          this.currentGECorrespondingTable
        )
      ).then(ge => {
        this.currentGECorrespondingTable = ge;
      });
    } catch (error) {
      let customError: Error = { error: undefined };

      if (error.statusText == 'Unknown Error') {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      } else {
        if (error.error) {
          customError = error.error;
        }
        if (error.error.errors) {
          customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
        } else {
          if (error.error) {
            customError = error.error;
          }
        }
      }

      if (customError.error === undefined) {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      }
    }
  }

  createDisplayName() {
    let name = this.addSharemailBoxForm.get('sharemailboxName').value;
    if (name !== '') {
      name = name + ' - ' + this.currentGECorrespondingTable.service;
    }

    return name;
  }

  createMailAddress() {
    let name = this.addSharemailBoxForm.get('sharemailboxName').value;
    if (name !== '') {
      const geAdresse = this.currentGECorrespondingTable.service.replace(
        /[^a-zA-Z0-9]/g,
        ''
      );
      name = name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      name = name.replace(/[^a-zA-Z0-9._-]/g, '');
      name = name + '.' + geAdresse;
    }

    return name.toLowerCase();
  }

  removeAccess(user: UserInfo): void {
    const index = this.users_acces.indexOf(user);
    if (index >= 0) {
      this.users_acces.splice(index, 1);
    }
  }

  removeSendas(user: UserInfo): void {
    const index = this.user_sendAs_Nom.indexOf(user);
    if (index >= 0) {
      this.user_sendAs_Nom.splice(index, 1);
    }
  }

  cleanNomivativeList(type: string): void {
    if (type === 'a') {
      this.users_acces = [];
    } else if (type === 's') {
      this.user_sendAs_Nom = [];
    }
  }

  addUserForAccess(): void {
    const dialogRef = this._matDialog.open(AddUserDialogComponent, {
      data: {
        _users: this.users_acces.map(user => user.officialemail),
        singleUser: false,
      },
      panelClass: 'add-user-dialog',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((selectedusers: UserInfo[]) => {
      for (const user of selectedusers) {
        const temp = new UserInfo();
        temp.officialemail = user.officialemail;
        this.users_acces.push(temp);
      }
    });
  }

  addUserForSendAs(): void {
    const dialogRef = this._matDialog.open(AddUserDialogComponent, {
      data: {
        _users: this.user_sendAs_Nom.map(user => user.officialemail),
        singleUser: false,
      },
      panelClass: 'add-user-dialog',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(selectedusers => {
      for (const user of selectedusers) {
        const temp = new UserInfo();
        temp.officialemail = user.officialemail;
        this.user_sendAs_Nom.push(temp);
      }
    });
  }

  private fetchressourceformData(): SharemailboxListFields {
    const nomUserList = [];
    for (const user of this.users_acces) {
      nomUserList.push(user.officialemail);
    }

    const sendAs_NomList = [];
    for (const user of this.user_sendAs_Nom) {
      sendAs_NomList.push(user.officialemail);
    }

    return {
      // Standard Config
      type: 'Sharemailbox',
      etatdelabo_x00ee_te: SharemailboxStatus.CREATE,
      ge: this.firstCharToUpper(this.currentGE),
      demandeur: this.currentUser.officialemail,

      // Forms
      title: this.createDisplayName(),
      nom_x0020_officiel: this.createMailAddress(),

      // Personnel technique
      rqarFullAccessGrTechnique: this.firstCharToUpper(this.ajout_Tech),
      rqarSendAsGrTechnique: this.firstCharToUpper(this.sendas_Tech),

      // Personnel administratif
      rqarFullAccessGrAdministratif: this.firstCharToUpper(this.ajout_admin),
      rqarSendAsGrAdministratif: this.firstCharToUpper(this.sendas_admin),

      // Secrétaire de direction
      rqarFullAccessGrSecretaireDirect: this.firstCharToUpper(
        this.ajout_secDir
      ),
      rqarSendAsGrSecretaireDirection: this.firstCharToUpper(
        this.sendas_secDir
      ),

      // IT-Responsable
      rqarFullAccessGrITResponsable: this.firstCharToUpper(this.ajout_ITRes),
      rqarSendAsGrITResponsable: this.firstCharToUpper(this.sendas_ITRes),

      // IT-Gestionnaire
      rqarFullAccessGrITGestionnaire: this.firstCharToUpper(this.ajout_ITGest),
      rqarSendAsGrITGestionnaire: this.firstCharToUpper(this.sendas_ITGest),

      // Directeur
      rqarFullAccessGrDirecteur: this.firstCharToUpper(this.ajout_Directeur),
      rqarSendAsGrDirecteur: this.firstCharToUpper(this.sendas_Directeur),

      // Conseil de Direction
      rqarRFullAccessGrConseilDirection: this.firstCharToUpper(
        this.ajout_ConseilDir
      ),
      rqarSendAsGrConseilDirection: this.firstCharToUpper(
        this.sendas_ConseilDir
      ),

      rqarFullAccessUsersOrGroups: nomUserList.join(';'),
      rqaSendAsUsersOrGroups: sendAs_NomList.join(';'),
    };
  }

  async createSharemailbox(): Promise<void> {
    this.errorCreateSharemailbox = { error: { message: '', code: '' } };
    this.isErrorCreateSharemailbox = false;
    this.issharemailboxCreated = false;
    this.isBusyCreateSharemailbox = true;

    try {
      const newSharemailbox = this.fetchressourceformData();

      await lastValueFrom(
        this._graphService.addSharemailbox(newSharemailbox)
      ).then(() => {
        this.issharemailboxCreated = true;
        this.isBusyCreateSharemailbox = false;
      });
    } catch (error) {
      let customError: Error = { error: undefined };

      if (error.statusText == 'Unknown Error') {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      } else {
        if (error.error) {
          customError = error.error;
        }
        if (error.error.errors) {
          customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
        } else {
          if (error.error) {
            customError = error.error;
          }
        }
      }

      if (customError.error === undefined) {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      }

      this.isErrorCreateSharemailbox = true;
      this.errorCreateSharemailbox = customError;
      this.issharemailboxCreated = false;
      this.isBusyCreateSharemailbox = false;
    }
  }

  private firstCharToUpper(input: string | boolean): string {
    return String(input).charAt(0).toUpperCase() + String(input).slice(1);
  }
}
